export default __webpack_public_path__ + "static/media/sweatShirt.ba496177.svg";